import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M25.236 6.833A12.93 12.93 0 0 0 16.1 3H16A13 13 0 0 0 3 16v7a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3H5.045a11.015 11.015 0 0 1 18.773-6.759A10.92 10.92 0 0 1 26.956 15H24a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h3a3 3 0 0 1-3 3h-7a1 1 0 0 0 0 2h7a5 5 0 0 0 5-5V16a12.93 12.93 0 0 0-3.764-9.167M8 17a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-6zm16 7a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h3v7z"
    />
  </svg>
);
const SvgIconSupport = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSupport);
export default Memo;
